<template>
	<transition name="modal">
		<div class="modal-mask" @click="$emit('close')">
			<div class="modal-wrapper">
				<div class="modal-container-attrib" @click.stop>
					<div class="modal-header">
						<slot name="header"> {{ $t('_selectionnez_le_ou_les_points_de_mesure_associe_') }}</slot>
						<slot name="cross">
							<v-icon style="float: right;" @click="$emit('close')">mdi-close</v-icon>
						</slot>
					</div>

					<div class="modal-body">
						<multiselect v-model="ptDeMesure" :options="sortedMpps" :multiple="true"
							:close-on-select="false" :clear-on-select="false" :hide-selected="true"
							:preserve-search="true" placeholder="" label="mpp" track-by="mpp" selectLabel="" class="select">
							<template slot="tag" slot-scope="props">
								<span class="custom__tag"
									style="background-color: lightgray; border-radius: 15px; padding: 5px;">
									<span>{{ props.option.mpp }}</span>
									<span class="custom__remove" style="margin: 5px;"
										@click="props.remove(props.option)">
										<v-icon>mdi-close</v-icon>
									</span>
								</span>
							</template>
						</multiselect>
					</div>

					<div class="modal-footer">
						<slot name="footer">
							<v-btn style="float: right; right: 5px; " @click="OnValide()">
								{{ $t('_valider_') }}
							</v-btn>
						</slot>
					</div>
					<Choix v-if="modalState" @close="closeModal()" @saveUnseparated="$emit('save', send)"
						@separate="openSeparate()" />
					<Separation v-if="separate" :rectangleCoords="rectangleCoords" :ptDeMesure="send" :mpps="mpps"
						@close="closeSeparate()" @save="$emit('newSave', $event)"></Separation>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import api from '@/api/api';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Choix from './PopUpChoix.vue';
import Separation from './PopUpSeparation.vue';
import backend from '@/api/backend';

export default {
	name: "Attribution",

	components: { Multiselect, Choix, Separation },

	props: {
		rectangleCoords: {
			required: true
		},
		pastMpp: {
			required: true
		},
	},

	async mounted() {
		//Si le site existe dans la base d'helioicity, recuperer les infos la bas
		try {
			const res = await api.get_all_full_layout(this.installation_id)
			this.mpps = res.data
			this.mpps.forEach((element) => {
				element["id"]= element.mpp
				if (this.pastMpp.includes(element.mpp)) {
					this.ptDeMesure.push(element)
				}
			})
		}
		catch { //Sinon c'est que c'est un site créée dans l'appli, recuperer les info chez nous 
			const res = (await backend.get_install_form(this.installation_id)).data
			const historique = res.history
			const calepinage = res.layouts
			this.mpps = []
			for (const idLigne in calepinage) {
				const json = {}
				json["init_module_nb"] = calepinage[idLigne].initNbModule
				json["init_string_nb"] = calepinage[idLigne].initNbChaine
				for (let idOnduleur in historique) {
					if (historique[idOnduleur].nom === calepinage[idLigne].nomOnduleur)
						json["inv_model"] = historique[idOnduleur].type
				}
				json["module_nb"] = calepinage[idLigne].nbModule
				json["mpp"] = calepinage[idLigne].nom
				json["plane_id"] = calepinage[idLigne].nomRampant
				json["pv_model"] = calepinage[idLigne].typeModule
				json["string_nb"] = calepinage[idLigne].nbChaine
				json["id"]= calepinage[idLigne].cleMpp
				this.mpps.push(json)
			}
			this.mpps.forEach((element) => {
				if (this.pastMpp.includes(element.id)) {
					this.ptDeMesure.push(element)
				}
			})
		}


	},

	data() {
		return {
			installation_id: this.$route.params.id,
			ptDeMesure: [],
			mpps: [],
			modalState: false,
			separate: false,
			send: [],
		}
	},

	computed: {
		//eetourne les mpp triées
		sortedMpps() {
			return [...this.mpps].sort((a, b) => a.mpp.localeCompare(b.mpp, undefined, { sensitivity: 'base' }));
		},
	},

	methods: {
		OnValide() {
			for (let i = 0; i < this.ptDeMesure.length; i++) {
				this.send[i] = this.ptDeMesure[i].id;
			}
			if (this.send.length > 1) {
				this.modalState = true;
			}
			else {
				this.$emit('save', this.send);
			}
		},

		closeModal() {
			this.modalState = false;
		},

		openSeparate() {
			this.separate = true;
		},

		closeSeparate() {
			this.separate = false;
		}
	}

}

</script>

<style scoped>
.modal-container-attrib {
	width: 60vw;
	height: 60vh;
	margin: 0px auto;
	padding: 20px;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	border-radius: 0.25rem;
	position: relative;
}

.modal-header {
	font-weight: bold;
	font-size: 1.4rem;
}

.modal-body {
	margin: 20px 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.modal-default-button {
	float: right;
}

.modal-footer {
	padding: 16px 16px;
	background-color: white;
	color: white;
	position: absolute;
	bottom: 0;
	right: 0;
}

.select::v-deep .multiselect__option:hover{
background-color: #f7ba5f ;
color: black;
}
.select::v-deep .multiselect__option{
background-color: white ;
color: black;
}

</style>